import { makeStyles } from "@material-ui/core";
import React, { useState } from "react";

const useStyles = makeStyles((theme) => ({
    accordionButton: {
        cursor: 'pointer',
        background: 'none',
        border: 'none',
        verticalAlign: 'middle',
        "& span": {
            fontSize: theme.spacing(1.25),
            paddingLeft: theme.spacing(1)
        },
        "& span.down": {
            fontSize: theme.spacing(2.5),
            position: 'relative',
            top: '3px',
        }
    },
    accordionContent: {
        // padding: theme.spacing(1, 0)
    }
}))


export const ChatAccordion = ({ data }) => {
    const classes = useStyles()
    const [activeIndex, setActiveIndex] = useState(null);

    return (
        <div >
            {data.map((item, index) => (
                <div key={`accordion-${index}`} >
                    <button
                        className={classes.accordionButton}
                        onClick={() => setActiveIndex(activeIndex === index ? null : index)}
                        data-testid={`accordion-btn-${index}`}
                    >
                        {item.title}
                        {activeIndex === index ? <span className="down">&#9662;</span> : <span>&#9654;</span>}
                    </button>

                    {activeIndex === index && (
                        <div className={classes.accordionContent} data-testid={`accordion-ctnt-${index}`}>
                            {item.content}
                        </div>
                    )}
                </div>
            ))}
        </div>
    );
}